import React, { Fragment, useState } from "react"
import { GenericMuiDatagrid } from "../../../components/generic/GenericDatagrid"
import { GENERIC_COLUMN_PROPS, SOCIALS_KEY } from "../../../enums/generalEnums";
import { formatDate } from "../../../helpers/dateHelper";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { DAY_ONLY_FORMAT } from "../../../enums/dateEnums";
import { Star, Tag } from "@phosphor-icons/react";
import { GenericNoData } from "../../../components/generic/GenericNoData";
import { DeleteCategoryDialog } from "./DeleteCategoryDialog";

export const TagManagementTable = (props) => {
  const {
    requestData,
    customActions,
    setPagination,
    handleOpenDialog,
    title = 'Tag List',
    isEditable = false,
    alterList,
    type
  } = props;

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const handleDeleteCategory = (data) => {
    setOpenDeleteDialog(true);
    setSelectedCategory(data);
  };

  const ActionButtons = ({ row, direction }) => {
    return (
      <Stack gap={1} direction={direction} mt={1.1}>
        <Button variant="outlined" fullWidth onClick={() => handleOpenDialog(row)}>Edit</Button>
        <Button variant="contained" color="error" fullWidth onClick={() => handleDeleteCategory(row)}>Delete</Button>
      </Stack>
    )
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      renderCell: ({ row }) => <Fragment>
        {
          type === SOCIALS_KEY ? <Stack mt={1.5} direction={'row'} gap={1}>
            {row?.meta?.featured && <Star size={20} weight="fill" color="#f1c40f" />}
            <Typography fontWeight={700}>{row?.name}</Typography>
          </Stack> : <span style={{ fontWeight: 700 }}>{row?.name}</span>
        }
      </Fragment>,
      ...GENERIC_COLUMN_PROPS
    },
    {
      field: 'created_at',
      headerName: 'Date Created',
      flex: 1,
      renderCell: ({ row }) => formatDate(new Date(row?.created_at)),
      ...GENERIC_COLUMN_PROPS
    },
    {
      field: 'updated_at',
      headerName: 'Last Updated ',
      flex: 1,
      renderCell: ({ row }) => formatDate(new Date(row?.updated_at)),
      ...GENERIC_COLUMN_PROPS
    },
    {
      ...(customActions ?? {
        field: 'action',
        headerName: 'Action',
        flex: 1,
        renderCell: ({ row }) => {
          return (
            <ActionButtons row={row} direction={'row'} />
          );
        },
      }),
      ...GENERIC_COLUMN_PROPS,
    }
  ];

  return (
    <Fragment>
      {
        requestData?.data?.length > 0 ? <GenericMuiDatagrid
          {...requestData}
          hideFooter={false}
          columns={columns}
          height={{ md: '52vh', lg: '42vh' }}
          setPagination={setPagination}
        >
          {
            requestData?.data?.map((category, index) => {
              return (
                <Fragment key={`category-key-${index}`}>
                  <Box sx={{ padding: '16px' }}>
                    <Stack direction={'row'} justifyContent={'space-between'} mb={0.5}>
                      <Typography variant="h6" fontWeight={700}>{category?.name}</Typography>
                      <Typography color="text.light">{formatDate(new Date(category?.created_at), DAY_ONLY_FORMAT)}</Typography>
                    </Stack>
                    <Typography color="text.light" mb={1}>Last Updated: {formatDate(new Date(category?.created_at), DAY_ONLY_FORMAT)}</Typography>
                    {
                      isEditable ? <ActionButtons row={category} direction={'column'} /> : <Button variant="contained" fullWidth onClick={() => handleOpenDialog(category)}>Manage</Button>
                    }
                  </Box>
                  {index !== (requestData?.data?.length - 1) && <Divider sx={{ borderColor: 'borders.main' }} />}
                </Fragment>
              )
            })
          }
        </GenericMuiDatagrid> : <GenericNoData height={'40vh'} icon={<Tag size={40} />} label={`No ${title}`} />
      }
      {
        isEditable && <DeleteCategoryDialog
          selectedTag={selectedCategory}
          openDeleteDialog={openDeleteDialog}
          handleClose={() => setOpenDeleteDialog(false)}
          alterList={alterList}
        />
      }
    </Fragment>
  )
};